<template>
    <div v-if="recipe">    
        <div class="breadcrumbs-container">
            <nav class="breadcrumb is-medium" aria-label="breadcrumbs">
            <ul>
                <li><router-link :to="{name: 'Home'}">  
                    Home
                </router-link></li>
                <li>
                <router-link :to="{name: 'Browse Recipes'}">  
                    Recipes
                </router-link>                        
                </li>
                <li>
                  <router-link  :to="{name: 'Kitchen', params: {id: recipe.user_id}}">  
                    {{recipe.kitchen_name}}'s Kitchen
                  </router-link>                        
                </li>
                <li class="is-active">
                <a href="#">  
                    {{recipe.name}}
                </a>                        
                </li>
            </ul>
            </nav>
        </div>
        <section>    
            <div class="container radley">    
                <div class="columns is-centered">    
                    <div class="column">  
                        <div>    
                        <article class="media">
                            <figure class="media-left">
                            <div 
                            class="recipe-avatar image"
                            v-if="recipe.mainImage[0]" 
                            :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+recipe.mainImage[0]+'?alt=media)' }">
                            </div>
                                <div class="has-text-centered">
                                    <star-rating 
                                    class="is-pulled-left"
                                    v-model="rating" 
                                    :star-size="20" 
                                    :show-rating="false" 
                                    @rating-selected="selectRating"></star-rating><strong>({{recipe.num_ratings}})</strong>
                                </div>
                            </figure>
                            <div class="media-content">
                                <div class="content">
                                    <div class="is-size-5"><span class="is-size-2 caveat">{{recipe.name}}</span><br />
                                        <small>From the Kitchen of 
                                        <router-link :to="{name: 'Kitchen', params: {id: recipe.user_id}}">  
                                            <strong>{{recipe.kitchen_name}}</strong>
                                        </router-link>
                                        <!--{{created_at}}-->
                                        </small><br />
                                    </div>
                                    <small v-if="recipe.inspired_by != null">Inspired by 
                                        <a v-bind:href="'/recipe/'+ recipe.inspired_by.id + '/' + recipe.inspired_by.slug">
                                            <strong>{{recipe.inspired_by.name}}</strong>
                                        </a>
                                        <!--{{created_at}}-->
                                        </small><br/>
                                    <em class="text-line-breaks">{{recipe.subtitle}}</em>
                                </div>
                            </div>
                            <div class="media-right">
                                <Like :recipe="recipe" :key="recipe.id"></Like>
                                <div class="is-pulled-right">
                                    <button class="button is-primary add-rounded mt-5" slot="trigger"                            
                                        @click="openModal(recipe.id)">
                                        <b-icon icon="plus"></b-icon>
                                    </button>
                                </div>
                            </div>
                            </article>
                            <b-message type="is-primary" class="mt-20" v-if="recipe.quickreference">
                                <div class="media quickreference">
                                    <div class="media-left">
                                    <b-icon
                                        pack="fas"
                                        icon="lightbulb"
                                        size="is-large">
                                    </b-icon>
                                    </div>
                                    <div class="media-content">
                                        {{recipe.quickreference}}
                                    </div>
                                </div>            
                            </b-message>
                            <div class="content mt-20">
                                <div>
                                    <nav class="level time-serving-levels">    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Prep Time</p>    
                                                <p class="title">
                                                    <span v-if="recipe.prepTime.hours > 0">{{recipe.prepTime.hours}} hr </span>
                                                    <span v-if="recipe.prepTime.minutes > 0">{{recipe.prepTime.minutes}} min</span>
                                                    <span v-if="(recipe.prepTime.minutes + recipe.prepTime.hours) == 0">0 min</span>
                                                </p>
                                            </div>    
                                        </div>    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Cook Time</p>    
                                                <p class="title">
                                                    <span v-if="recipe.cookTime.hours > 0">{{recipe.cookTime.hours}} hr </span>    
                                                    <span v-if="recipe.cookTime.minutes > 0">{{recipe.cookTime.minutes}} min</span>
                                                    <span v-if="(recipe.cookTime.minutes + recipe.cookTime.hours) == 0">0 min</span>
                                                </p>
                                            </div>    
                                        </div>    
                                        <div class="level-item has-text-centered">    
                                            <div>    
                                                <p class="heading">Servings</p>    
                                                <p class="title">{{recipe.servings}}</p>    
                                            </div>    
                                        </div>    
                                    </nav>    
                                </div> 
                                <div class="mt-50">
                                <div class="columns">
                                <div class="column is-4 ingredient-list">
                                <b-collapse
                                    class="card">
                                    <div
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header recipe-header"
                                        role="button">
                                        <p class="card-header-title">
                                            Ingredients
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon
                                            pack="fas"
                                                :icon="props.open ? 'caret-up' : 'caret-down'">
                                            </b-icon>
                                        </a>
                                    </div>
                                    <div class="card-content">
                                        <div class="content">                                 
                                                <table class="table is-striped">  
                                                <tbody>
                                                    <tr v-for="ingredient in recipe.ingredients" :key="ingredient.id">
                                                    <td>   
                                                    <div class="field">
                                                        <b-checkbox>
                                                            <span v-html="ingredient.amount"></span>&nbsp;<span v-if="ingredient.measurement">{{ingredient.measurement}},&nbsp;</span>{{ingredient.ingredient}}
                                                        </b-checkbox>
                                                    </div>                                                            
                                                    </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            <div class="mt-50" v-if="recipe.secondPart != null">                         
                                                <h3 class="is-size-5 p-12">For the {{recipe.secondPart.name}}</h3>
                                                <table class="table is-striped">  
                                                <tbody>
                                                    <tr v-for="(ingredient, index) in recipe.secondPart.ingredients" :key="ingredient.id">
                                                    <td  v-if="index <= (recipe.secondPart.ingredients.length/2)">   
                                                    <div class="field">
                                                        <b-checkbox>
                                                            <span v-html="ingredient.amount"></span>&nbsp;<span v-if="ingredient.measurement">{{ingredient.measurement}},&nbsp;</span>{{ingredient.ingredient}}
                                                        </b-checkbox>
                                                    </div>                                                            
                                                    </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>  
                                        </div>
                                    </div>
                                </b-collapse>  
                                </div>
                                <div class="column is-8">
                                <b-collapse
                                    class="card">
                                    <div
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header recipe-header"
                                        role="button">
                                        <p class="card-header-title">
                                            Instructions
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon
                                            pack="fas"
                                                :icon="props.open ? 'caret-up' : 'caret-down'">
                                            </b-icon>
                                        </a>
                                    </div>
                                    <div class="card-content">
                                        <div class="content">
                                            <!-- Post content -->    
                                            <div v-for="(item,index) in recipe.steps" :key="item.id">    
                                                <div v-if="item.image" class="columns">
                                                    <div class="column is-two-thirds step-flex">    
                                                        <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div>
                                                        <div class="step-content"><span>{{item.text}}</span></div>  
                                                    </div>    
                                                    <div class="column is-one-third">    
                                                        <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+item.image+'?alt=media'" style="width:100%;" />    
                                                    </div>   
                                                </div>
                                                <div v-else>
                                                    <div class="step-flex">    
                                                        <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div> 
                                                        <div class="step-content"><span>{{item.text}}</span></div> 
                                                    </div>   
                                                </div>   
                                            </div>
                                            <div class="mt-50" v-if="recipe.secondPart != null">
                                                <h3 class="is-size-5 p-12">For the {{recipe.secondPart.name}}</h3> 
                                                <div v-for="(item,index) in recipe.secondPart.steps" :key="item.id">    
                                                    <div v-if="item.image" class="columns">
                                                        <div class="column is-two-thirds step-flex">    
                                                            <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div>
                                                            <div class="step-content"><span>{{item.text}}</span></div>  
                                                        </div>    
                                                        <div class="column is-one-third">    
                                                            <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+item.image+'?alt=media'" style="width:100%;" />    
                                                        </div>   
                                                    </div>
                                                    <div v-else>
                                                        <div class="step-flex">    
                                                            <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div> 
                                                            <div class="step-content"><span>{{item.text}}</span></div> 
                                                        </div>   
                                                    </div>   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-collapse> 
                                </div>
                                </div>
                                </div>
                                <div class="mt-20 has-text-centered image-slider">  
                                    <carousel 
                                    :navigationEnabled="true" 
                                    :perPage="1" 
                                    paginationColor="rgba(0, 0, 0, 0.25)"
                                    v-if="recipe.secondPart != null">    
                                        <slide v-for="mainImage in recipe.mainImage" :key="mainImage.id">    
                                            <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+mainImage+'?alt=media'"  />   
                                            <div class="has-text-centered">{{recipe.name}}</div>
                                        </slide>   
                                        <slide v-for="mainImage in recipe.secondPart.mainImage" :key="mainImage.id">    
                                            <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+mainImage+'?alt=media'"  />   
                                            <div class="has-text-centered">{{recipe.name}}</div>
                                        </slide> 
                                    </carousel>     
                                    <carousel 
                                    :navigationEnabled="true" 
                                    :perPage="1" 
                                    paginationColor="rgba(0, 0, 0, 0.25)"
                                    v-else>    
                                        <slide v-for="mainImage in recipe.mainImage" :key="mainImage.id">    
                                            <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+mainImage+'?alt=media'"  />   
                                            <div class="has-text-centered">{{recipe.name}}</div>
                                        </slide>   
                                    </carousel>    
                                </div> 
                                <div class="mt-20">
                                <div class="author-name is-capitalized is-size-3 has-text-centered">From the kitchen of <b>
                                <router-link :to="{name: 'Kitchen', params: {id: recipe.user_id}}"> {{recipe.kitchen_name}}</router-link></b></div>    
                                <div class="is-size-5 has-text-centered"><i class="sl sl-icon-clock"></i> {{created_at}}</div>    
                                </div>
                                <hr>    
        
                                <div class="" id="tagSection">    
                                  
                                    <span v-for="tag in recipe.tags" :key="tag.id">
                                    <router-link :to="{name: 'tagged', params: {id: tag}}">
                                    <b-tag type="is-dark" size="is-medium">#{{tag}}</b-tag>&nbsp;    
                                    </router-link>
                                    </span>
                                </div>   
                            </div>    
                        </div>    
           
                        
                    </div>      
                </div>    
            </div>    
        </section>    
        <b-modal :active.sync="isComponentModalActive"
                    has-modal-card
                    trap-focus
                    aria-role="dialog"
                    aria-modal>                
                    <Add :userMeals="user_meals" :menus="menus" :selectedRecipe="selectedRecipe" :userData="userData"></Add>
                </b-modal>  
        <!-- /Post section -->            
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import firebase from '@/firebase';
import db from '@/db';
import moment from 'moment';
import StarRating from 'vue-star-rating';
import { Carousel, Slide } from 'vue-carousel';
import Like from '../components/Like.vue';
import Add from '../components/Add.vue';

export default {

    name: "Recipe",
    data() {
        return {
            id: this.$route.params.id,
            ratingRef: Object,
            user_id: null,
            userData:null,
            created_at: String,
            isActive: false,
            rating: null,
            open:true,
            isComponentModalActive: false,
            selectedRecipe:null,
            isLoggedIn:firebase.auth().currentUser
        }
    },
    components: {
        StarRating,
        Carousel,
        Slide,
        Like,
        Add
    },
    async mounted() {
        await this.init();
        this.fetchData();
    },
    computed: {
        ...mapState('recipe', ['recipe', 'user_meals', 'menus']),
    },
    methods: {
        fetchData() {
            db.collection('recipes').doc(this.id)
                .get().then(docSnapshot => {
                    if (!docSnapshot.exists) return;
                    this.rating = this.recipe.rating;
                    this.created_at = moment(this.recipe.created_at.toDate()).fromNow();
                });
        
            
                if (this.isLoggedIn) {
                    this.user_id = this.isLoggedIn.uid;
                    this.ratingRef = db.collection('recipeRatings').doc(this.user_id + ':' + this.id);
                    db.collection('users').doc(this.user_id)
                        .get().then(docSnapshot => {
                            if (!docSnapshot.exists) return;
                            this.userData = docSnapshot.data();
                    });
                }
        },
        selectRating() {
            if (this.isLoggedIn) {
                const ratingRef = this.ratingRef;
                const user_id = this.user_id;
                const recipe_id = this.recipe.id;
                let rating = this.rating;
                
                this.ratingRef.get().then(function(doc) {
                    if (doc.exists) {
                        ratingRef.set({
                            id: user_id + ":" + recipe_id,
                            user_id: user_id,
                            recipe_id: recipe_id,
                            rating: rating
                        });
                    } else {
                        ratingRef.set({
                            id: user_id + ":" + recipe_id,
                            user_id: user_id,
                            recipe_id: recipe_id,
                            rating: rating
                        });
                    }
                    
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
            }
            else {
                console.log('not logged in')
            }
            // console.log(this.rating);            
        },
        openModal(recipe) {
            if(this.userData) {
                this.isComponentModalActive = true;
                this.selectedRecipe = recipe;
            }
            else {
                this.$router.replace("/login");
            }
        },
        ...mapActions('recipe', ['init']),
    }
}
</script>
